/**
 * @file Renders the switch that limits the transactions table to the failed
 * transactions, with the failed count in its label.
 */
import React from "react";
import { Switch, Typography } from "antd";

const { Text } = Typography;

const SWITCH_ID = "failed-transactions-switch";
const LABEL_FAILED_TRANSACTIONS = "Failed transactions";

const LABEL_STYLE = {
  gap: 8,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
};

type Props = {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  failedTransactionsCount: number;
};

/**
 * Renders the switch with the label "Failed transactions (X)". The label
 * element makes the text clickable, because the switch is a native button.
 */
const FailedTransactionsSwitch = ({
  isChecked,
  onChange,
  failedTransactionsCount,
}: Props) => (
  <label
    style={LABEL_STYLE}
    htmlFor={SWITCH_ID}
  >
    <Switch
      id={SWITCH_ID}
      size="small"
      checked={isChecked}
      onChange={onChange}
    />
    <Text>
      {LABEL_FAILED_TRANSACTIONS} ({failedTransactionsCount})
    </Text>
  </label>
);

export default FailedTransactionsSwitch;
